if (!customElements.get('country-province')) {
  class CountryProvinceForm extends HTMLElement {
    constructor() {
      super();
      this.provinceElement = this.querySelector('[name="address[province]"]');
      this.countryElement = this.querySelector('[name="address[country]"]');
      this.countryElement.addEventListener('change', this.handleCountryChange.bind(this));
      this.init();
    }

    init() {
      if (this.dataset.country) {
        this.countryElement.selectedIndex = Math.max(
          0,
          Array.from(this.countryElement.options).findIndex(
            (option) => option.textContent.trim() === this.dataset.country
          )
        );
      }
      this.countryElement.dispatchEvent(new Event('change'));
    }

    handleCountryChange() {
      const option = this.countryElement.options[this.countryElement.selectedIndex];
      if (!option) return;
      const provinces = JSON.parse(option.dataset.provinces || '[]');

      this.provinceElement.closest('.form-field').hidden = provinces.length === 0;
      if (provinces.length === 0) return;

      this.provinceElement.innerHTML = '';
      provinces.forEach((data) => {
        const selected = data[1] === this.dataset.province;
        this.provinceElement.options.add(new Option(data[1], data[0], selected, selected));
      });
    }
  }
  customElements.define('country-province', CountryProvinceForm);
}

if (!customElements.get('shipping-calculator')) {
  class ShippingCalculator extends HTMLFormElement {

    static cartOpenListenerCounter = 2; // Number of times the rebuy cart open listener is called (the listener is called twice)

    constructor() {
      super();
      this.submitButton = this.querySelector('[type="submit"]');
      this.resultsElement = this.lastElementChild;
      this.submitButton.addEventListener('click', this.handleFormSubmit.bind(this));
      this.onCartOpenBound = this.onCartOpen.bind(this);
    }

    getVariantId() {
      // Prefer the currently selected variant from the product form on the page
      const productForm = document.querySelector('form[action*="/cart/add"]');
      if (productForm) {
        const variantInput = productForm.querySelector('[name="id"]');
        if (variantInput) return variantInput.value;
      }
      // Fallback to the data attribute set at page load
      return this.dataset.variantId;
    }

    jsonHeaders() {
      return { 'Content-Type': 'application/json', Accept: 'application/json' };
    }
    /*DOESN'T WORK
    // Suppress cart modals by injecting a CSS rule with !important.
    // This is timing-proof: no matter when Rebuy reacts to the cart mutation,
    // the element stays visually hidden until we remove the style tag.
    suppressCartModals() {
      document.getElementById("rebuy-cart-close").click();
      return;
      const style = document.createElement('style');
      style.textContent = [
        '#rebuy-cart',
        'cart-drawer',
        '[data-cart-drawer]',
      ].join(',') + ' { display: none !important; }';
      document.head.appendChild(style);
      return () => style.remove();
    }

    restoreModals() {
    }
    */

    // Close the rebuy cart when an item is added/changed to it
    onCartOpen(e) {
      e.preventDefault();
      e.stopPropagation();
      console.log("listen to cart rebuy");
      console.log(ShippingCalculator.cartOpenListenerCounter);
      if (--ShippingCalculator.cartOpenListenerCounter == 0) {
          document.removeEventListener('rebuy:smartcart.show', this.onCartOpenBound, true);
          console.log("removed rebuy cart listener");
          ShippingCalculator.cartOpenListenerCounter = 2;
          Rebuy.SmartCart.hide();
      }
      Rebuy.SmartCart.hide();
    }

    async handleFormSubmit(event) {
      event.preventDefault();
      const zip = this.querySelector('[name="address[zip]"]').value;
      const country = this.querySelector('[name="address[country]"]').value;
      const province = this.querySelector('[name="address[province]"]').value;
      const variantId = this.getVariantId();
      // Get the current quantity selected of the current variant.
      const quantity = document.querySelector('[name="quantity"]').value ?? 1;
      //console.log("q", quantity);

      this.submitButton.classList.add('btn--loading');

      // Start suppressing cart modals before any cart mutation
      //const restoreModals = 
      //this.suppressCartModals();

      try {
        // 1. Check the current cart to know the original quantity of this variant
        const cartRes = await fetch('/cart.js', { headers: this.jsonHeaders() });
        const cart = await cartRes.json();
        const existingItem = cart.items.find((item) => String(item.variant_id) === String(variantId));
        const originalQty = existingItem ? existingItem.quantity : 0;

        // 1.1 Store item quantities if any.
        const itemQuantities = []
        if (existingItem) {
          itemQuantities.push({ id: existingItem.variant_id, quantity: originalQty });
        }
        for (const item of cart.items) {
          if (item.variant_id == variantId) continue;
          itemQuantities.push({ id: item.variant_id, quantity: item.quantity });
        }
        if (itemQuantities) ShippingCalculator.cartOpenListenerCounter+=2; //the listener is called twice

        // 1.2. Set the items in the carts to 0
        await fetch('/cart/clear.json', {
          method: 'POST',
          headers: this.jsonHeaders()
        });

        document.addEventListener('rebuy:smartcart.show', this.onCartOpenBound, true);
        // 2. Add the variant temporarily so the API has something to calculate against
        await fetch('/cart/add.json', {
          method: 'POST',
          headers: this.jsonHeaders(),
          body: JSON.stringify({ id: variantId, quantity: quantity }),
        });

        // 3. Fetch shipping rates for the provided address
        const ratesUrl = `${FoxTheme.routes.cart_url}/shipping_rates.json`.replace('//', '/');
        const ratesRes = await fetch(ratesUrl, {
          method: 'POST',
          headers: this.jsonHeaders(),
          body: JSON.stringify({ shipping_address: { zip, country, province } }),
        });
        const parsedState = await ratesRes.json();

         //// 4. Restore original cart quantity (removes the item if it wasn't there before)
        // 4. Remove the current item used to calculate shipping cost
        await fetch('/cart/change.json', {
          method: 'POST',
          headers: this.jsonHeaders(),
          body: JSON.stringify({ id: variantId, quantity: 0 }),
        });

        // 4. Restore original cart quantities
        if (itemQuantities.length > 0) {
          await fetch('/cart/add.json', {
            method: 'POST',
            headers: this.jsonHeaders(),
            body: JSON.stringify( {items: itemQuantities} )
          });
        }

        // 5. Render results
        if (parsedState.shipping_rates) {
          this.formatShippingRates(parsedState.shipping_rates);
        } else {
          this.formatError(parsedState);
        }
      } catch (e) {
        console.error(e);
      } finally {
        //console.log("removing listener");
        /*setTimeout(() => {
          document.removeEventListener('rebuy:smartcart.show', this.onCartOpen, true);
        }, 1000);*/
        this.resultsElement.hidden = false;
        this.submitButton.classList.remove('btn--loading');
      }
    }

    formatError(errors) {
      const items = Object.keys(errors).map((k) => `<li>${errors[k]}</li>`);
      this.resultsElement.innerHTML = `
        <div class="alert alert--error blocks-radius grid gap-2">
          <p class="font-body-bolder m-0">${FoxTheme.shippingCalculatorStrings.error}</p>
          <ul class="list-disc grid gap-1 text-sm" role="list">${items.join('')}</ul>
        </div>`;
    }

    formatShippingRates(shippingRates) {
      const items = shippingRates.map(
        ({ presentment_name, currency, price }) => `<li>${presentment_name}: ${currency} ${price}</li>`
      );
      const count = shippingRates.length;
      const message =
        count === 0
          ? FoxTheme.shippingCalculatorStrings.notFound
          : count === 1
          ? FoxTheme.shippingCalculatorStrings.oneResult
          : FoxTheme.shippingCalculatorStrings.multipleResults;

      this.resultsElement.innerHTML = `
        <div class="alert blocks-radius alert--${count === 0 ? 'error' : 'success'} grid gap-2 leading-tight">
          <p class="font-body-bolder m-0">${message}</p>
          ${count > 0 ? `<ul class="list-disc grid gap-1 text-sm" role="list">${items.join('')}</ul>` : ''}
        </div>`;
    }
  }
  customElements.define('shipping-calculator', ShippingCalculator, { extends: 'form' });
}
